import type { PmsSourceKey } from '@/types/pms.types';
import type { IntegrationStatus } from '../services/pmsConnectionApi';

/**
 * Vendor settings page access gate (spec §4.7). Decided from the RTK status
 * slice — the account has one PMS connection, and only that vendor's page is
 * reachable while it exists (active, disabled OR flag-off). `none` admits every
 * vendor (first connection). Callers must not decide while the status is still
 * loading; `useIntegrationStatus` reads `none` during load, which would admit
 * the wrong vendor for a frame.
 *
 * The Buildium exception: its marketplace OAuth flow returns to
 * /vendor/buildium?token=… before any connection exists on the account, and
 * may do so while another vendor's stale connection is still stored. Today's
 * behavior (VendorDefinition.hasAccess, retired here) admitted it; kept.
 */
export function hasVendorAccess(
  vendorKey: PmsSourceKey,
  status: IntegrationStatus,
  search: URLSearchParams,
): boolean {
  if (status.kind === 'none') return true;
  if (status.pmsSource === vendorKey) return true;
  return vendorKey === 'buildium' && search.has('token');
}
